import environment from "@environment";
import { RequestHelper } from "@lib-shared/lib";
import { InstallationResponse } from "core/models/installation-response";
import { FindInstallationResponse } from "core/models/search-response";

class FourSureService {
    private _apiUrl = environment.fourSureApiUrl;

    constructor() {
    }

    findAsync(value: string) {
        const request = {
            customer_number_or_cellphone: value
        }
        return this._post<FindInstallationResponse>("find", request)
    }

    validateAsync(value: string, otp: string) {
        const request = {
            customer_number_or_cellphone: value,
            otp: otp
        }
        return this._post<InstallationResponse>("validate", request);
    }

    private _post<T>(path: string, request: any) {
        const helper = new RequestHelper(this._apiUrl).withPath(path);
        return helper.usingPromise().post<T>(request);
    }

}

export default FourSureService;
